<div class="events-page-container">
  <div class="header-section">
    <header class="events-header">
      <div class="header-spacer" aria-hidden="true"></div>
      <h1 class="header-title">Les événements</h1>
      <div class="header-spacer" aria-hidden="true"></div>
    </header>
  </div>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
  <app-navbar></app-navbar>
</div>
